import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export const OPTIONS_STORE_ACCESS = {
  ACTIONS: {
    FIND_ACCESS: 'access/findAccess',
    CLEAR_ACCESS: 'access/clearAccess'
  },
  GETTERS: {
    GET_ACCESS: 'access/getAccess'
  }
};

export default {
  state: {
    access: []
  },
  actions,
  getters,
  mutations,
  namespaced: true
};
